import { render, staticRenderFns } from "./WYSIWYGEditor.vue?vue&type=template&id=4764ab95&scoped=true&"
import script from "./WYSIWYGEditor.vue?vue&type=script&lang=ts&"
export * from "./WYSIWYGEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WYSIWYGEditor.vue?vue&type=style&index=0&id=4764ab95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764ab95",
  null
  
)

export default component.exports